import React, { Component } from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import logo from '../../../../images/brand/jlogo.png';
import './GuestHeader.scss';

const Contact = styled.div`
  height: 100%;
  width: 100%;
  display: block;
  padding-top: 24px;
  padding-right: 20px;
  background: linear-gradient(white, #efefef);
`;

const Phone = styled.span`
  color: #cf2631;
  float: right;
`;

const Opening = styled.span`
  color: #828282;
  float: right;
  clear: right;
`;

export default class GuestHeader extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      mobileDropdown: false,
    };

    this.recomputeState = ::this.recomputeState;
  }

  componentDidMount() {
    this.on(
      ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'],
      this.recomputeState,
    );
  }

  componentWillUnmount() {
    this.off(
      ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'],
      this.recomputeState,
    );
  }

  recomputeState() {
    if (this.getDistanceFromTop() < -100) {
      return this.setState({ collapsed: true });
    }

    this.setState({ collapsed: false });
  }

  getDistanceFromTop() {
    if (this.refs.header) {
      return this.refs.header.getBoundingClientRect().top;
    }
    return 0;
  }

  on(events, callback) {
    events.forEach((evt) => {
      window.addEventListener(evt, callback);
    });
  }

  off(events, callback) {
    events.forEach((evt) => {
      window.removeEventListener(evt, callback);
    });
  }

  render() {
    return (
      <div>
        <div className="header-publics">
          <Link to="/">
            <img alt="logo" className="guest-logo" src={logo} />
          </Link>
          {/*<Contact>*/}
          {/*  <Phone>0800 458 0466</Phone>*/}
          {/*  <Opening>brokers@justtravelcover.com</Opening>*/}
          {/*</Contact>*/}
        </div>
      </div>
    );
  }
}
